import { CardTransaction } from "~/application/types";
import { CardTransactionDTO } from "../dtos";
import { toDate } from "~/utils/date.utils";
import { mapExpenseCardDTO } from "./mapExpenseCardDTO";
import { mapAccountabilityExpenseDTO } from "./mapAccountabilityExpenseDTO";

export function mapCardTransactionDTO(data: CardTransactionDTO): CardTransaction {
  return {
    id: data.uuid,
    cardId: data.card_uuid,
    externalCardId: data.external_card_id,
    externalNsu: data.external_nsu,
    externalOriginalNsu: data.external_original_nsu,
    externalReferenceId: data.external_reference_id,
    amount: parseFloat(data.amount),
    merchantName: data.merchant_name,
    merchantCity: data.merchant_city,
    merchantState: data.merchant_state,
    merchantCategoryCode: data.merchant_category_code,
    type: data.transaction_type,
    description: data.transaction_description,
    externalHash: data.external_hash,
    issuerCardId: data.issuer_card_id,
    branchId: data.branch_id,
    clientId: data.client_id,
    transactedAt: toDate(data.transacted_at),
    card: data.card ? mapExpenseCardDTO(data.card) : undefined,
    status: data.expense_proof_status,
    expense: data.expense && mapAccountabilityExpenseDTO(data.expense),
  };
}
